import React from 'react'
export default function ContactUsPage(){
     return(
        <div>
        <h2 className='mb-4 text-lg structure__main__subttl'>Contact Us</h2>
        <p className='text-sm mb-12'>You can contact to info@devcookbooks.com to ask any questions.<br/>
        </p>
        <br/>
        </div>
     )
}
